import { render, staticRenderFns } from "./TouchInBagSelectBottomModal.vue?vue&type=template&id=c3918f04&scoped=true"
import script from "./TouchInBagSelectBottomModal.vue?vue&type=script&lang=js"
export * from "./TouchInBagSelectBottomModal.vue?vue&type=script&lang=js"
import style0 from "./TouchInBagSelectBottomModal.vue?vue&type=style&index=0&id=c3918f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3918f04",
  null
  
)

export default component.exports